export default {"src":"/_next/static/media/cocktail_brown.f128895e.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};